// no itx for this file
import SettingsPage from "../components/SettingsPane/SettingsPage";
import universalstorageHandler, { enumStorageMode } from "../persistence/UniversalstorageHandler";
import { CheckboxFieldSettings } from "../SettingsScreen";
import { itx } from "../translationItx/itx";
import Dropdown from "react-dropdown-select";

export default function SettingPageDevelopment(props: {
  handler: string;
  dropDownColor: string;
  setRefresh?: (number: number) => void;
  refresh?: number;
}) {
  const { dropDownColor, setRefresh, refresh } = props;

  return (
    <SettingsPage
      handler="/settings/development" // no itx
    >
      <label
        className="form-label-bold"
        htmlFor="uiMode" // no itx
        key={"projectStorage_label"} // no itx
      >
        {itx("SettingsScreen.projectStorage", "Projektablage")}
      </label>
      <Dropdown
        name="storageMode" // no itx
        key={universalstorageHandler.storageMode}
        className={`prefixMode form-dropdown input-standard`}
        options={[
          {
            value: enumStorageMode.local,
            label: itx("SettingsScreen.local", "local"),
          },
          {
            value: enumStorageMode.server,
            label: itx("SettingsScreen.server", "server"),
          },
        ]}
        values={[
          {
            value: universalstorageHandler.storageMode,
            label:
              universalstorageHandler.storageMode == enumStorageMode.local
                ? itx("SettingsScreen.local", "local")
                : itx("SettingsScreen.server", "server"),
          },
        ]}
        onChange={(item: any) => {
          if (item) {
            universalstorageHandler.storageMode = item[0].value;
            universalstorageHandler.updateStorageHandler();
            if (setRefresh && refresh) setRefresh(refresh + 1);
          }
        }}
        color={dropDownColor}
        searchable={false}
        clearable={false}
      />
      <CheckboxFieldSettings
        name="debugTranslation" // no itx
        label={itx("SettingsScreen.debugTranslation", "debugTranslation")}
        setRefresh={setRefresh}
        refresh={refresh}
      />
    </SettingsPage>
  );
}
